import { GET_SECURITY_QUESTIONS_SUCCESS } from "../types/securityQuestionType";

const initialState = {
    securityQuestions: [],
    securityQuestionError: null
};

const securityQuestionReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_SECURITY_QUESTIONS_SUCCESS:
            return {
                ...state,
                securityQuestions: payload
            };
        default:
            return state;
    }
};

export default securityQuestionReducer;
